import { configureStore } from '@reduxjs/toolkit';
import gameReducer from '../data/gameSlice';
import boardReducer from '../data/boardSlice';

export default configureStore({
  reducer: {
    game: gameReducer,
    board: boardReducer,
  },
});